import {createAction} from "redux-act";
import {IAchievement, IAvatar, ICard, IHelp, ITeam} from "modules/reducers";

export interface IGetSettingsResponse {
	background: string;
	adImage: string;
	adLink: string;
	cards: ICard[];
}

export const requestSettings = createAction();
export const requestSettingsSuccess = createAction<IGetSettingsResponse>();
export const requestSettingsFailed = createAction();

export interface ITeamsResponse {
	favoriteTeams: ITeam[];
}

export const requestTeams = createAction();
export const requestTeamsSuccess = createAction<ITeam[]>();
export const requestTeamsFailed = createAction();

export interface IHelpPagesResponse {
	faqs: IHelp[];
	guidelines: IHelp[];
	terms: IHelp[];
}

export const requestHelpPages = createAction();
export const requestHelpPagesSuccess = createAction<IHelpPagesResponse>();
export const requestHelpPagesFailed = createAction();

export interface IAvatarsResponse {
	avatars: IAvatar[];
}

export const requestAvatars = createAction();
export const requestAvatarsSuccess = createAction<IAvatar[]>();
export const requestAvatarsFailed = createAction();

export interface IAchievementsResponse {
	achievements: IAchievement[];
}

export const requestAchievements = createAction();
export const requestAchievementsSuccess = createAction<IAchievement[]>();
export const requestAchievementsFailed = createAction();

export type TCountries = Record<string, string>;

export const requestCountries = createAction();
export const requestCountriesSuccess = createAction<TCountries>();
export const requestCountriesFailed = createAction();
